var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.998 4.88782V6.88457C8.998 7.01436 8.99299 7.13916 8.97798 7.25897C8.86286 8.60678 8.06707 9.27569 6.6006 9.27569H6.4004C6.27527 9.27569 6.15515 9.33559 6.08008 9.43543L5.47948 10.2341C5.21421 10.5886 4.78378 10.5886 4.51852 10.2341L3.91791 9.43543C3.85285 9.35057 3.70771 9.27569 3.5976 9.27569H3.3974C1.80081 9.27569 1 8.88133 1 6.88457V4.88782C1 3.4252 1.67568 2.63149 3.02203 2.51668C3.14215 2.5017 3.26727 2.4967 3.3974 2.4967H6.6006C8.1972 2.4967 8.998 3.29541 8.998 4.88782Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 2.89112V4.88787C11.0001 6.35548 10.3244 7.1442 8.97803 7.25902C8.99305 7.13921 8.99805 7.01441 8.99805 6.88462V4.88787C8.99805 3.29546 8.19725 2.49676 6.60065 2.49676H3.39747C3.26734 2.49676 3.14221 2.50175 3.02209 2.51673C3.13721 1.17391 3.93301 0.5 5.39945 0.5H8.60266C10.1993 0.5 11.0001 1.29871 11.0001 2.89112Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75354 6.11584H6.7585",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00171 6.11584H5.00666",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 6.11584H3.25557",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.d1e3855b260e9cbd0e6ff41dc9052e5d.svg";
export { ForwardRef as ReactComponent };